import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {PocCheckSeverity, PocWizardState} from '../../model/poc-wizard-state.interface';
import {PocWizardStateService} from '../../service/poc-wizard-state.service';
import {NsNotificationTypeInternal} from '../../../../enum/ns-notification-type-internal.enum';

@Component({
    selector: 'poc-step-review',
    templateUrl: './poc-step-review.component.html',
    styleUrls: ['./poc-step-review.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PocStepReviewComponent {
    @Input() state: PocWizardState;
    @Output() activate = new EventEmitter<void>();
    @Output() editStep = new EventEmitter<number>();

    PocCheckSeverity = PocCheckSeverity;

    constructor(private wizardState: PocWizardStateService) {}

    get typeLabel(): string {
        return this.state.basics.notificationTypeInternal === NsNotificationTypeInternal.REGULAR
            ? 'Einzelne Benachrichtigung' : 'Wiederverwendbare Vorlage';
    }

    get selectedChannels() {
        return this.state.channelConfigs.filter(c => c.selected);
    }

    getSeverityIcon(severity: PocCheckSeverity): string {
        switch (severity) {
            case PocCheckSeverity.pass: return 'fa-solid fa-check-circle text-green-600';
            case PocCheckSeverity.warning: return 'fa-solid fa-exclamation-triangle text-yellow-600';
            case PocCheckSeverity.error: return 'fa-solid fa-times-circle text-red-600';
            case PocCheckSeverity.info: return 'fa-solid fa-info-circle text-blue-500';
        }
    }

    onBack(): void {
        this.wizardState.goToStep(3);
    }

    onActivate(): void {
        this.activate.emit();
    }

    onEdit(step: number): void {
        this.editStep.emit(step);
    }
}
